import React from 'react';
import Layout from '@/common/Layout';
import WeeklyList from './components/index';

const index = () => {
  return (
    <div>
      <Layout sider={false}>
        <WeeklyList />
      </Layout>
    </div>
  );
};

export default index;
